import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { validateState, VALIDATION_EMPTY_FIELD } from '../../../hooks/useForm/validate';
import { useValidateState } from '../../../hooks/useValidateState';

export const useValidate = ({ defaultValue, validator, helperText, required }) => {
    const { t: translate } = useTranslation();
    const [errorText, changeError] = useValidateState(validator, defaultValue, required, translate);

    const validate = useCallback(
        (valueToValidate) => {
            const fieldValue = valueToValidate === '' ? undefined : valueToValidate;
            const validationResult = validateState(validator, fieldValue, required, translate) || {};
            changeError(validationResult.errorText);

            return !validationResult.errorText;
        },
        [validator, required, translate]
    );

    const customHelperText = useMemo(() => {
        if (errorText === translate(VALIDATION_EMPTY_FIELD)) {
            return errorText;
        }
        return errorText || helperText || '';
    }, [errorText, helperText, translate]);

    return { errorText, customHelperText, validate };
};
